/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Empty_TitleInputs */



/**
* | output |
* | --- |
* | "No shares yet" |
*
* @param {Team_Share_Empty_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_empty_title = /** @type {((inputs?: Team_Share_Empty_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Empty_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("No shares yet")
	if (locale === "de") return /** @type {LocalizedString} */ ("No shares yet")
	if (locale === "it") return /** @type {LocalizedString} */ ("No shares yet")
	if (locale === "ru") return /** @type {LocalizedString} */ ("No shares yet")
	if (locale === "es") return /** @type {LocalizedString} */ ("No shares yet")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("No shares yet")
	if (locale === "ja") return /** @type {LocalizedString} */ ("No shares yet")
	if (locale === "hi") return /** @type {LocalizedString} */ ("No shares yet")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("No shares yet")
	return /** @type {LocalizedString} */ ("No shares yet")
});